import type { SalesLeadHeat, SalesOrgLeadDetail, ShareToChatSubject } from "@xop/dashboard-shared";

/** Human label for a lead's heat (the autonomous-agent urgency). */
const HEAT_LABEL: Record<SalesLeadHeat, string> = {
  cold: "Cold",
  warm: "Warm",
  hot: "Hot",
  on_fire: "On fire",
};

/**
 * Build the "share to chat" subject for a sales-agent lead. The summary is a
 * one-line heat · vertical badge plus the org domain — no monetary fields. The
 * deep link is the lead detail route (matched by the chat applink allowlist).
 */
export function salesLeadShareSubject(lead: SalesOrgLeadDetail): ShareToChatSubject {
  const heatVertical = [HEAT_LABEL[lead.heat], lead.vertical].filter(Boolean).join(" · ");
  return {
    kind: "Sales lead",
    title: lead.name,
    summaryLines: [heatVertical, lead.domain ?? ""],
    deepLinkPath: `/sales/leads/${lead.id}`,
  };
}
